

var PostTypes = function()
{

	var postTypesApp = this;

	/**
	 * [postType description]
	 * @return {[type]} [description]
	 */
	this.postType = function()
	{

		var pt = this;

		/**
		 * [updateTableRow description]
		 * @param  {[type]} response   [description]
		 * @param  {[type]} attributes [description]
		 * @return {[type]}            [description]
		 */
		this.updateTableRow = function( response, attributes )
		{
			var row =  $('[data-for="fields-list"] [data-field-id="' + response.id + '"]');
			$('[data-for="field-label"]', row).text( response.label );
			$('[data-for="field-type"]', row).text( response.field_type_display );
		};

		/**
		 * [addTableRow description]
		 * @param {[type]} response   [description]
		 * @param {[type]} attributes [description]
		 */
		this.addTableRow = function( response, attributes )
		{
			var row = $('<tr />').attr('data-field-id', response.id);
			var id = $('<td />').attr('data-for', 'field-id').text(response.id);
			var label = $('<td />').attr('data-for', 'field-label').text(response.label);
			var type = $('<td />').attr('data-for', 'field-type').text(response.type_display);
			var buttonsW = $('<td />');
			var buttons = $('<div />').addClass('ui small icon basic buttons');
			var editButton = $('<a />')
				.addClass( 'ui button' )
				.attr( 'data-for', 'edit-field' )
				.attr( 'data-trigger-id', response.id)
				.attr( 'href', response.edit_url)
				.html( '<i class="align edit green icon"></i>' );
			var deleteButton = $('<a />')
				.addClass( 'ui button' )
				.attr( 'data-for', 'delete-field' )
				.attr( 'data-trigger-id', response.id)
				.attr( 'href', response.delete_url)
				.html( '<i class="align trash red icon"></i>' );

			row.append(id).append(label).append(type);
			buttons.append(editButton).append(deleteButton);
			buttons.appendTo(buttonsW);
			row.append(buttonsW);

			var defaultRow = $('[data-for="fields-list"] [data-for="no-results-row"]');
			if( defaultRow.length ) {
				defaultRow.remove();
			}

			row.appendTo($('[data-for="fields-list"]'));
			pt.bindEvents();

		};

		/**
		 * [addDefaultNoResultsRow description]
		 */
		this.addDefaultNoResultsRow = function( tbody )
		{
			var row = $('<tr />').attr('data-for', 'no-results-row');
			$('<td />').attr('colspan', 4).text('You currently have no fields attached').appendTo(row);
			row.appendTo(tbody);
		};

		/**
		 * [removeTableRow description]
		 * @param  {[type]} response   [description]
		 * @param  {[type]} attributes [description]
		 * @return {[type]}            [description]
		 */
		this.removeTableRow = function( response, attributes )
		{
			$('[data-for="fields-list"] tr[data-field-id="' + response.id + '"]').fadeOut(200, function(){
				$(this).remove();
				if( ! $('[data-for="fields-list"] tr').length ) {
					pt.addDefaultNoResultsRow( $('[data-for="fields-list"]') );
				}
			});
		};

		/**
		 * [fieldEditHandler description]
		 * @return {[type]} [description]
		 */
		this.fieldEditHandler = function(e)
		{
			e.preventDefault();
			$.fn.ensphere.veto.modalEdit( this, {
				onVisible : function( modalObj ){
                    $.fn.ensphere.veto.wysiwyg( '.redactor', modalObj );
					setTimeout( function(){
						modalObj.semanticUiModal('refresh');
					}, 500);
				},
				onComplete : function( response, attributes, modalObj ){
					pt.updateTableRow( response, attributes );
                    modalObj.semanticUiModal('hide');
				}
			});
		};

		/**
		 * [addFieldHandler description]
		 * @param {[type]} e [description]
		 */
		this.addFieldHandler = function(e)
		{
			e.preventDefault();
			$.fn.ensphere.veto.modalEdit( this, {
				onVisible : function( modalObj ){
					$.fn.ensphere.veto.wysiwyg( '.redactor', modalObj );
					setTimeout( function(){
						modalObj.semanticUiModal('refresh');
					}, 500);
				},
				onComplete : function( response, attributes, modalObj ){
					pt.addTableRow( response, attributes );
					modalObj.semanticUiModal('hide');
				}
			});
		};

		/**
		 * [deleteFieldHandler description]
		 * @param  {[type]} e [description]
		 * @return {[type]}   [description]
		 */
		this.deleteFieldHandler = function(e)
		{
			e.preventDefault();
			$.fn.ensphere.veto.modalEdit( this, {
				onResponse : function( response, attributes ){
					pt.removeTableRow( response, attributes );
				}
			});
		};

		this.categories = function()
		{
            $('#categories').tagsInput({
                defaultText : 'add a category...'
                // autocomplete_url : autocompleteUrl
            });
		};

		/**
		 * [bindEvents description]
		 * @return {[type]} [description]
		 */
		this.bindEvents = function()
		{
			$.fn.ensphere.veto.select('[data-for="edit-field"]').forEach(function(elm){
				$.fn.ensphere.veto.clickEvent( elm, pt.fieldEditHandler );
			});
			$.fn.ensphere.veto.select('[data-for="add-new-field"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, pt.addFieldHandler );
			});
			$.fn.ensphere.veto.select('[data-for="delete-field"]').forEach(function(elm){
                $.fn.ensphere.veto.clickEvent( elm, pt.deleteFieldHandler );
			});
			this.categories();
			$.fn.ensphere.veto.wysiwyg( '.wysiwyg' );
		};


		return new (function(){

			/**
			 * [init description]
			 * @return {[type]} [description]
			 */
			this.init = function()
			{
				pt.bindEvents();
			};

		});

	};

	/**
	 * [init description]
	 * @return {[type]} [description]
	 */
	this.init = function()
	{

		var postTypeApp = new postTypesApp.postType();
		postTypeApp.init();
		$.fn.ensphere.veto.wysiwyg( '.redactor' );
	};


};


jQuery(document).ready( function($){

	if( $('.create.post-type, .edit.post-type, .edit.post-type-post, .create.post-type-post').length )
	{
		$('.orderable').rowSorter({
			onDrop: function(tbody, row, new_index, old_index) {
		        var table = $(tbody.tagName.toLowerCase() === "tbody" ? tbody.parentNode : tbody);
		        var ids = [];
		        $('tbody tr', table).each(function(){
		        	ids.push( $(this).attr('data-field-id') );
		        });
		        $.ajaxSetup({
		            headers: { 'X-CSRF-TOKEN': $('[name="_token"]').val() }
		        });
		        $.post( $('#order-url').val(), { orders : ids }, function( response ){
		        	console.log(response);
		        });
		    },
		});

		var app = new PostTypes();
		app.init();
	}


	if( $( '.posts.list' ).length ) {
		var wrapper = $( '.posts.list' );
		var postTypeID = $('[name="post_type_id"]', wrapper).val();
		var token = $('[name="_token"]').val();
		var url = $('[name="order_url"]').val();
		$('.orderable').rowSorter({
			onDrop: function(tbody, row, new_index, old_index) {
		        var table = $(tbody.tagName.toLowerCase() === "tbody" ? tbody.parentNode : tbody);
		        var ids = [];
		        $('tbody tr', table).each(function(){
		        	ids.push( $(this).attr('data-field-id') );
		        });
		        $.ajaxSetup({
		            headers: { 'X-CSRF-TOKEN': token }
		        });
		        $.post( url, { orders : ids }, function( response ){
		        	console.log(response);
		        });
		    }
		});
	}

    if( $( '.re-order' ).length ) {
        var token = $('[name="_token"]').val();
        $('.orderable').each( function(){
            var url = $(this).attr( 'data-url' );
            $(this).rowSorter({
                onDrop: function(tbody, row, new_index, old_index) {
                    var table = $(tbody.tagName.toLowerCase() === "tbody" ? tbody.parentNode : tbody);
                    var ids = [];
                    $('tbody tr', table).each(function(){
                        ids.push( $(this).attr('data-id') );
                    });
                    $.ajaxSetup({
                        headers: { 'X-CSRF-TOKEN': token }
                    });
                    $.post( url, { orders : ids }, function( response ){
                        console.log(response);
                    });
                }
            });

        });
    }

});
